import { H4 } from "../typography/H4";

interface Props {
  quote: any;
}

export const PartnerCreateOrderHeader: React.FC<Props> = ({ quote }) => {
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between h-[50px] mb-[12px]">
        <div className="mt-[15px] mb-[7px] flex ">
          <H4 className="text-semantic-text-heading">발주서 작성</H4>
        </div>
        <div />
      </div>
    </div>
  );
};
